import {vnTemplate} from "../../../vendor/valnet/valnet_jslib/vnKnockoutJsTemplates/vnTemplate";

declare var ko: any;


export class filterUser_template extends vnTemplate {


    static SINGLE_SELECTION_MODE: string = 'single';
    static MULTIPLE_SELECTION_MODE: string = 'multiple';


    protected tagContainerId: string = 'filters-selected';
    protected tagContainerCaption: string = 'Selected Filters:';
    /** Callers that need to tell a cleared user filter apart from any other change opt in to receive the idElement. */
    protected notifyIdElementOnChange: boolean = false;

    protected getTemplateHtml(): string {

        return `
                <div class="w-spec-search icon i-auto-complete i-user2" data-bind="visible: isVisible, css: { disable: disabled }, attr: {id: uniqueIdentifier}">
                    <input data-bind="disable: isGlobalLockEnabled(), event: { keyup: onChangeInput}, valueUpdate: ['afterkeydown', 'input'], attr:{id:idUser, placeholder: placeholder}, textInput: user" list="users" class="input-text">
                        <!-- ko if: isLoadingAnimationEnable() && optionsLoading() -->
                            <span class="form-loading" ></span>
                        <!-- /ko -->
                        <ul class="form-auto-list" data-bind="foreach: users,  visible: isShowUserSuggestions" id="users">
                            <li class="form-auto-item" data-bind="attr:{id:id}, text: $data.valnet_user.fullNameAndLogin, click: $parent.onBlurUser, clickBubble: false" ></li>
                        </ul>
                    </input>
                    <button data-bind="event: { click: onClearInput }, attr : { id : 'user-input-close_' + $element.parentElement.id }, clickBubble: false" class="close-btn icon i-x-after"><span class="hidden-text">close</span></button>
                </div>
                `;
    }

    protected getTemplateName(): string {

        return "filterUser-template";
    }

    protected getMainElementClasses(): Array<string> {

        return [];
    }

    protected buildViewModel(): any {

        // define the viewmodel data/ functions
        let self = this;
        return {
            selectionMode: ko.observable(filterUser_template.SINGLE_SELECTION_MODE),
            users: ko.observableArray([]),
            idUser: ko.observable(null),
            user: ko.observable(""),
            userObject: ko.observable(null),
            userObjects: ko.observableArray([]),
            placeholder: ko.observable("User"),
            orderBy: "dateCreation",
            orderByDirection: "DESC",
            disabled: ko.observable(false),
            isShowUserSuggestions: ko.observable(false),
            isVisible: ko.observable(true),
            uniqueIdentifier: ko.observable('userIdentifier'),
            isGlobalLockEnabled : ko.observable(false),
            isLoadingAnimationEnable: ko.observable(false),
            optionsLoading: ko.observable(false),
            currentInputValue: ko.observable(null),
            onChangeInput: (data, event): void => {
                self.onChangeInput(event);
            },
            onClearInput:  (data, event): void => {
                self.onClearInput(event);
            },
            onChangeFilterAction:  (data, event): void => {
                self.onChangeFilterAction(data)
            },
            onBlurUser:  (data, event): void => {
                self.onBlurUser(data, event);
            }
        };
    }

    public setNotifyIdElementOnChange(notify: boolean): void {

        this.notifyIdElementOnChange = notify;
    }

    protected notifyCallerOnChange(): void {

        this.caller.filterSimpleOnChange(this.notifyIdElementOnChange ? this.idElement : undefined);
    }

    protected onChangeFilterAction(data) {

        this.notifyCallerOnChange();
    }

    protected onChangeInput(event) {

        let input = event.target;
        let inputWrapper = input.parentNode;
        let closeBtnId = `#user-input-close_${this.getUniqueIdentifier()}`;
        let closeBtn = inputWrapper.querySelector(closeBtnId);
        if (!closeBtn.classList.contains('is-showing')) {
            closeBtn.classList.add('is-showing');
        }

        this.setOptionsLoading(true);
        this.onChangeUserDataListUser(event, this.viewModel[this.idElement].idUser);
    }

    protected onChangeUserDataListUser(event, idUser) {

        let input = event.target,
            inputVal = input.value,
            optionsList = input.getAttribute('list'),
            options: any = document.getElementById("articles") ? document.getElementById("articles").childNodes : [];

        this.setCurrentInputValue(inputVal);

        if (inputVal.length >= 3) {
            this.caller.getUsersSuggestion(inputVal, this.idElement);
            this.setIsShowUserSuggestions(true);
        }
        else {
            this.setUsers([])
            this.setIsShowUserSuggestions(false);
        }

        for (let op of options) {
            if (op.value === inputVal) {
                idUser(op.id);
                input.blur();
                this.notifyCallerOnChange();
                break;
            }
        }

    }

    protected onClearInput(event) {

        let button = event.target;
        this.setIsShowUserSuggestions(false);
        if (button.classList.contains('is-showing')) {

            this.clearData();
            this.notifyCallerOnChange();
        }
    }

    protected clearInput(){
        let closeBtnId = `#user-input-close_${this.getUniqueIdentifier()}`;
        let closeBtn = document.querySelector(closeBtnId);
        this.setIsShowUserSuggestions(false);
        this.setOptionsLoading(false);

        if (closeBtn && closeBtn.classList.contains('is-showing')) {

            this.clearData();
            this.notifyCallerOnChange();
        }
    }

    public clearData() {
        let closeBtnId = `#user-input-close_${this.getUniqueIdentifier()}`;
        let closeBtn = document.querySelector(closeBtnId);
        if (closeBtn) {
            closeBtn.classList.remove('is-showing');
        }
        if (this.isSingleSelectionMode()) {
            this.resetTagContainer();
        }
        this.setIdUser(null);
        this.setUser('');
        this.setUserObject(null);
    }

    public toggleCloseButton(): void {

        let inputWrapper = document.getElementById(this.getUniqueIdentifier());

        if (inputWrapper) {
            let closeBtnId = `#user-input-close_${this.getUniqueIdentifier()}`;
            let closeBtn = inputWrapper.querySelector(closeBtnId);
            let idUser = this.getIdUser();

            if (idUser == null || idUser == "") {
                closeBtn.classList.remove('is-showing');
            } else {
                closeBtn.classList.add('is-showing');
            }
        }
    }


    protected onBlurUser(data, event) {

        this.setUserInfo(data);

        this.handleSelectionModeSpecific({id: data.id, name: data.valnet_user.fullName});
        this.setUsers([]);
        this.setIsShowUserSuggestions(false);
        this.setOptionsLoading(false);
        this.resetCurrentInputValue();

        this.caller.filterSimpleOnChange(this.idElement);
    }

    private handleSelectionModeSpecific(selectedUser: { name: any; id: any }): void {

        if (this.isMultipleSelectionMode()) {
            if (this.getUserObjects().length == 0) {
                this.addCaption();
            }
            this.appendUserToSelection(selectedUser);
            this.clearInput();
        } else {
            this.replaceUserInSelection(selectedUser);
        }
    }

    public setTagContainerId(id: string) {

        this.tagContainerId = id;
    }

    public setTagContainerCaption(caption: string) {

        this.tagContainerCaption = caption;
    }

    protected addCaption() {

        if (this.getTagContainer()) {

            if (!this.hasCaption()) {

                this.getTagContainer().appendChild(this.createCaption());
            }
        }
    }

    protected hasCaption(): boolean {
        let captions = this.getTagContainer().getElementsByTagName('label');

        return (captions.length > 0);

    }

    public addUserTag(user) {

        if(this.getTagContainer()) {
            this.getTagContainer().appendChild(this.createHtmlTag(user));
        }
    }

    protected createCaption() {

        let element = document.createElement('label');

        element.setAttribute('class', 'small');
        element.appendChild(document.createTextNode(this.tagContainerCaption));

        return element;
    }

    protected createHtmlTag(user) {

        let self = this;

        let element = document.createElement('button');

        element.setAttribute('id', user.id);
        element.appendChild(document.createTextNode(user.name));
        element.setAttribute('class', 'btn-f-s icon i-x-after');
        element.setAttribute('type', 'button');

        element.addEventListener('click', function (e) {
            // @ts-ignore
            self.removeUserFromSelection(e.target.getAttribute('id'));
            // @ts-ignore
            self.getTagContainer().removeChild(e.target);
            if (self.getUserObjects().length == 0) {
                self.resetTagContainer();
            }

            self.caller.filterSimpleOnChange(self.idElement);
        }, false);

        return element;
    }

    protected getTagContainer() {

        return document.getElementById(this.tagContainerId);
    }

    public resetTagContainer(): void {
        if (this.getTagContainer()) {
            this.getTagContainer().innerHTML = '';
            this.setUserObjects([]);
        }
    }

    public setPlaceholderText(text){

        this.getTemplateViewModel().placeholder(text);
    }


    public setSelectionMode(selectionMode): void {
        this.getTemplateViewModel().selectionMode(selectionMode);
    }

    public getSelectionMode() {
        return this.getTemplateViewModel().selectionMode();
    }

    public setUsers(users): void {
        this.setOptionsLoading(false);
        this.getTemplateViewModel().users(users);
    }

    public getUsers() {
        return this.getTemplateViewModel().users();
    }

    public setIdUser(idUser): void {
        this.getTemplateViewModel().idUser(idUser);
    }

    public getIdUser() {
        return this.getTemplateViewModel().idUser();
    }

    public setUser(user): void {

        this.getTemplateViewModel().user(user);
    }

    public setUserInfo(user): void {

        this.setUserObject(user);
        this.setUser(user.valnet_user.fullNameAndLogin);
        this.setIdUser(user.id);
    }

    public getUser() {
        return this.getTemplateViewModel().user();
    }

    public setUserObject(userObject): void {
        this.getTemplateViewModel().userObject(userObject);
    }

    public getUserObject() {
        return this.getTemplateViewModel().userObject();
    }

    public setUserObjects(userObjects): void {
        this.getTemplateViewModel().userObjects(userObjects);
    }

    public getUserObjects() {
        return this.getTemplateViewModel().userObjects();
    }

    public setPlaceholder(placeholder): void {
        this.getTemplateViewModel().placeholder(placeholder);
    }

    public getPlaceholder() {
        return this.getTemplateViewModel().placeholder();
    }

    public setOrderBy(orderBy): void {
        this.getTemplateViewModel().orderBy = orderBy;
    }

    public getOrderBy() {
        return this.getTemplateViewModel().orderBy;
    }

    public setOrderByDirection(orderByDirection): void {
        this.getTemplateViewModel().orderByDirection = orderByDirection;
    }

    public getOrderByDirection() {
        return this.getTemplateViewModel().orderByDirection;
    }

    public setDisabled(disabled: boolean): void {
        this.getTemplateViewModel().disabled(disabled);
    }

    public getDisabled(): boolean {
        return this.getTemplateViewModel().disabled();
    }

    public setIsShowUserSuggestions(isShowUserSuggestions): void {
        this.getTemplateViewModel().isShowUserSuggestions(isShowUserSuggestions);
    }

    public getIsShowUserSuggestions() {
        return this.getTemplateViewModel().isShowUserSuggestions();
    }

    public setIsVisible(isVisible: boolean): void {
        this.getTemplateViewModel().isVisible(isVisible);
    }

    public getIsVisible(): boolean {
        return this.getTemplateViewModel().isVisible();
    }

    public setUniqueIdentifier(uniqueIdentifier: string): void {
        this.getTemplateViewModel().uniqueIdentifier(uniqueIdentifier);
    }

    public getUniqueIdentifier(): string {
        return this.getTemplateViewModel().uniqueIdentifier();
    }

    public setIsGlobalLockEnabled(isGlobalLockEnabled: boolean): void {
        this.getTemplateViewModel().isGlobalLockEnabled(isGlobalLockEnabled);
    }

    public getIsGlobalLockEnabled() {
        return this.getTemplateViewModel().isGlobalLockEnabled();
    }


    private appendUserToSelection(userInfo: {id: number, name: string}): void {
        let userObjects = this.getUserObjects();
        let filtered = userObjects.filter((t) => t.id == userInfo.id);
        if (filtered.length == 0) {

            userObjects.push(userInfo);
            this.addUserTag(userInfo);
            this.setUserObjects(userObjects);
        }
    }

    private replaceUserInSelection(user): void {
        this.setUserObjects([]);
        this.setUserObjects([user]);
    }

    private removeUserFromSelection(userId): void {
        let tags = this.getUserObjects().filter((u) => u.id != userId);
        this.setUserObjects(tags);
    }

    public getUsersForRequest() {
        return this.getUserObjects().map((u) => {
            return {id: u.id, name: u.name};
        });
    }

    public asMultipleSelectionMode(): void {
        this.setSelectionMode(filterUser_template.MULTIPLE_SELECTION_MODE);
    }

    public isMultipleSelectionMode(): boolean {
        return this.isSelectionMode(filterUser_template.MULTIPLE_SELECTION_MODE);
    }

    public isSingleSelectionMode(): boolean {
        return this.isSelectionMode(filterUser_template.SINGLE_SELECTION_MODE);
    }

    public isSelectionMode(selectionMode: string): boolean {
        return (this.getSelectionMode() == selectionMode);
    }

    public setSelectedUsersFromRequestParams(users): void {

        if (this.isSingleSelectionMode()) return;

        this.resetTagContainer();

        if (users.length > 0) {
            this.addCaption();
        }
        for (const user of users) {
            this.appendUserToSelection(user);
        }
    }

    public setIsLoadingAnimationEnable(boolean){

        this.getTemplateViewModel().isLoadingAnimationEnable(boolean)
    }

    public setOptionsLoading(isLoading) {
        this.getTemplateViewModel().optionsLoading(isLoading);
    }

    public setCurrentInputValue(value) {
        this.getTemplateViewModel().currentInputValue(value);
    }

    public getCurrentInputValue() {
        return this.getTemplateViewModel().currentInputValue();
    }

    public resetCurrentInputValue() {
        this.getTemplateViewModel().currentInputValue(null);
    }
}



// WEBPACK FOOTER //
// ./js/components/templates/filterUser_template.ts